import PT from 'prop-types';

// mui imports
import { Box, styled, Typography } from '@mui/material';
import { useMediaQuery } from '@material-ui/core';

const BoxCont = styled(Box)(({ theme }) => {
  const { functions } = theme;

  const { pxToRem } = functions;
  // const s = useMediaQuery('(min-width:600px)');
  const phone = useMediaQuery('(max-width:500px)');
  const tab = useMediaQuery('(max-width:850px)');
  return {
    padding: pxToRem(15),
    backgroundColor: '#e0e5ec !important',
    boxShadow: '0.3rem 0.3rem 0.5rem #6b6868, -0.2rem -0.2rem 0.4rem #fff !important',
    borderRadius: '25px',
    marginTop: phone ? '50px !important' : tab ? '50px !important' : '0'
  };
});

const ContentContainer = props => {
  return (
    <BoxCont as="section">
      <Typography
        sx={{
          fontSize: '26px !important',
          fontWeight: 'bold'
        }}>
        {props.title}
      </Typography>

      <Box sx={{ mt: 1 }}>{props.children}</Box>
    </BoxCont>
  );
};

ContentContainer.propTypes = {
  title: PT.string.isRequired,
  children: PT.node
};
export default ContentContainer;
